import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, X } from '@phosphor-icons/react';

import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { dismissAlertId, readDismissedAlertIds } from '../../utils/dismissedAlerts';

const DISMISS_KEY = 'guided-flow-return';

/**
 * `ds/banner--guided-return` no .pen — link discreto para voltar à jornada
 * guiada. X reaparece na próxima vez que `?from=guided` for usado.
 */
export function GuidedFlowReturnBanner() {
  const [params] = useSearchParams();
  const [dismissed, setDismissed] = useState(() => readDismissedAlertIds().has(DISMISS_KEY));

  if (params.get('from') !== 'guided' || dismissed) return null;

  return (
    <div className="mb-space-3 flex items-center gap-space-3 rounded-ds-lg border border-sage-border bg-sage-tint px-space-3 py-space-2-5">
      <Link
        to={`${paths.dashboard}?openGuidedFlow=1`}
        className="flex min-w-0 flex-1 items-center gap-space-2 text-type-body font-semibold text-sage-on-tint hover:underline"
      >
        <ArrowLeft className="h-4 w-4 shrink-0" aria-hidden />
        {pt.dashboard.guidedFlow.journeyTitle}
      </Link>
      <button
        type="button"
        onClick={() => {
          dismissAlertId(DISMISS_KEY);
          setDismissed(true);
        }}
        className="flex h-5 w-5 shrink-0 items-center justify-center text-muted-foreground hover:text-foreground"
        aria-label={pt.alerts.dismiss}
      >
        {/* eslint-disable-next-line no-restricted-syntax -- dimensão de ícone sem token exacto, alinhado com AlertItem */}
        <X className="h-[14px] w-[14px]" aria-hidden />
      </button>
    </div>
  );
}

export default GuidedFlowReturnBanner;
